export default "__VITE_ASSET__BvqZtBzW__"